import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import icon_thanh_cong from "../assets/icon_thanh_cong.png";

import { useDispatch, useSelector } from "react-redux";
import { getUserData, logout } from "../redux/slices/userSlices";
import { useNavigate } from "react-router-dom";
import { Scanner } from "@yudiel/react-qr-scanner";
import Api from "../components/api/api";
import { URL_API } from "../components/constants/api";
import { useAppTheme } from "../context/ThemeContext";

function Home() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataUser = useSelector(getUserData);
  const { bg, logo, content_bg, thanh_cong, da_duoc_su_dung, khong_hop_le } =
    useAppTheme();
  const [isScan, setIsScan] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [textScan, setTextScan] = useState("");
  const [txtSearch, setTxtSearch] = useState("");

  const [dataScan, setDataScan] = useState<any | null>(null);
  const [dataSearch, setDataSearch] = useState<any[]>([]);

  useEffect(() => {
    if (!dataUser) {
      navigate("/");
    }
    console.log("data", dataUser);
  }, [dataUser]);

  const handleScan = () => {
    setIsScan(true);
  };

  const onResultScan = (result: any) => {
    console.log(result);
    if (result) {
      if (result[0].format == "qr_code") {
        console.log("Code", result[0].rawValue);
        if (textScan === result[0].rawValue) return;
        setTextScan(result[0].rawValue);
      }
    }
  };

  useEffect(() => {
    if (textScan != "") {
      setIsLoading(true);
      checkCode(textScan);
    }
  }, [textScan]);

  const checkCode = async (code: string) => {
    const params = {
      code_id: code,
      pg_id: dataUser.id,
      location: dataUser.location,
    };
    const res: any = await Api.post(URL_API.SCAN, params);
    setIsLoading(false);
    console.log("handleSubmitForm", res, res.data);
    if (res.data.status == false) {
      setDataScan(res.data);
    } else {
      setDataScan(res.data);
    }
  };

  const acceptCode = async (code: string) => {
    setIsLoading(true);
    const params = {
      code_id: code,
      pg_id: dataUser.id,
      location: dataUser.location,
    };
    const res: any = await Api.post(URL_API.ACCEPT, params);
    setIsLoading(false);
    if (res.data.status == false) {
      setDataScan(res.data);
    } else {
      //ToastProvider({ type: "success", content: "Check-in thành công" });
      handleScanAgain();
    }
  };

  const handleAcceptCode = () => {
    acceptCode(textScan);
  };

  const handleScanAgain = () => {
    setDataScan(null);
    setTextScan("");
    setIsScan(false);
    setDataSearch([]);
    setIsLoading(false);
    setTxtSearch("");
  };

  useEffect(() => {
    console.log("dataSearch", dataSearch);
  }, [dataSearch]);

  const handleCheckInforSearch = (txt: string) => {
    setIsSearch(false);
    setIsLoading(true);
    setTextScan(txt);
  };

  useEffect(() => {
    console.log("dataScan", dataScan);
  }, [dataScan]);
  return (
    <div
      className="w-full h-full min-h-dvh bg-no-repeat bg-bottom bg-cover"
      style={{ backgroundImage: bg ? `url(${bg})` : undefined }}
    >
      <div className="flex flex-col min-h-dvh px-5 py-5 mx-auto w-full text-base font-bold max-w-[480px] text-neutral-800">
        <img loading="lazy" src={logo} className="w-full" />
        <div className="flex flex-col w-full relative mt-3">
          <img
            loading="lazy"
            src={content_bg}
            className="absolute top-0 left-0 w-full mix-blend-screen z-10"
          />

          {dataScan ? (
            <div className="relative w-full flex flex-col items-center justify-center min-h-full font-bold  z-20">
              {dataScan.status == false ? (
                <img
                  src={khong_hop_le}
                  onClick={handleScanAgain}
                  className="w-full"
                />
              ) : dataScan.info.is_checkin == 0 ? (
                <>
                  <img
                    src={thanh_cong}
                    onClick={handleAcceptCode}
                    className="w-full"
                  />
                  <div
                    className="absolute top-5 left-0 w-full "
                    onClick={handleAcceptCode}
                  >
                    <div className="flex mt-5 flex-col items-center w-[78%] mx-auto space-y-2">
                      <div className="font-normal text-xs text-center text-[#161d26] w-full">
                        Chào mừng ông/bà
                      </div>
                      {dataScan.info.full_name && (
                        <div className="font-bold text-base text-center text-[#ef7000] w-full">
                          {dataScan.info.full_name}
                        </div>
                      )}
                      {dataScan.info.company && (
                        <div className="font-normal text-xs text-center text-[#161d26] w-full">
                          Đại diện: <b>{dataScan.info.company}</b>
                        </div>
                      )}
                      <div className="font-normal text-xs text-center text-[#161d26] w-full">
                        đến tham dự chương trình
                      </div>
                      <img
                        loading="lazy"
                        src={icon_thanh_cong}
                        className="w-[60%] mx-auto"
                      />
                    </div>
                  </div>
                </>
              ) : (
                <img
                  src={da_duoc_su_dung}
                  onClick={handleAcceptCode}
                  className="w-full z-20"
                />
              )}
            </div>
          ) : (
            <div className="w-full mt-10">
              <div className="w-[70%] mx-auto min-h-[200px] rounded-[10px] overflow-hidden">
                <Scanner onScan={onResultScan} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
